import React from 'react'

const Hero = () => {
 return (
 <section style={{
 background: 'linear-gradient(135deg, rgba(255,107,139,0.1)0%, rgba(139,92,246,0.1)100%)',
 padding: '120px 0 80px',
 position: 'relative',
 overflow: 'hidden'
 }}>
 <div className="container">
 <div style={{
 display: 'grid',
 gridTemplateColumns: '1fr 1fr',
 gap: '60px',
 alignItems: 'center'
 }}>
 <div>
 <h1 style={{
 fontSize: '3.5rem',
 fontWeight: '800',
 lineHeight: '1.2',
 marginBottom: '24px',
 background: 'linear-gradient(135deg, #ff6b8b, #8b5cf6)',
 WebkitBackgroundClip: 'text',
 WebkitTextFillColor: 'transparent',
 backgroundClip: 'text'
 }}>
每一口都是<br />甜蜜的惊喜 </h1>
 <p style={{
 fontSize: '1.25rem',
 color: 'var(--text-light)',
 marginBottom: '40px',
 lineHeight: '1.6'
 }}>
专业烘焙师手工制作，精选优质原料，为您带来最纯正的甜蜜体验。从生日庆典到日常小确幸，我们用心烘焙每一份幸福。
 </p>
 <div style={{
 display: 'flex',
 gap: '16px',
 flexWrap: 'wrap'
 }}>
 <a href="#products" className="btn btn-primary">
立即选购 <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
 <path d="M5 12h14M12 5l7 7-7 7"></path>
 </svg>
 </a>
 <a href="#about" className="btn btn-secondary">
了解更多 </a>
 </div>
 </div>
 <div style={{
 position: 'relative',
 textAlign: 'center'
 }}>
 <div style={{
 width: '400px',
 height: '400px',
 background: 'linear-gradient(135deg, #ff6b8b, #8b5cf6)',
 borderRadius: '50%',
 margin: '0 auto',
 display: 'flex',
 alignItems: 'center',
 justifyContent: 'center',
 color: 'white',
 fontSize: '120px',
 boxShadow: '0 20px 40px rgba(255,107,139,0.3)'
 }}>
 🧁 </div>
 </div>
 </div>
 </div>
 </section>
 )
}

export default Hero